import { unstable_isUnrecognizedActionError } from 'next/navigation';

export function reloadIfStaleServerAction(error: unknown): boolean {
  if (!unstable_isUnrecognizedActionError(error)) {
    return false;
  }
  window.location.reload();
  return true;
}
